import { useState } from "react";
import { FEATURE_TABS, FEATURES_BIG, FEATURES_SMALL } from "@/mocks/kanliao";

export default function Featured() {
  const [tab, setTab] = useState(FEATURE_TABS[0]);

  return (
    <section id="featured" className="relative w-full bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-20 md:py-28">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">编辑精选 · 图文并重</span>
            <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-4xl">精选话题 · 大小卡混排</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              从黑料目录里挑出值得深读的档案与切片，图文并重，读着不累。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-1 rounded-full bg-secondary-100 p-1 md:px-1 md:py-1">
            {FEATURE_TABS.map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => setTab(t)}
                className={
                  "whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition " +
                  (tab === t
                    ? "bg-foreground-950 text-background-50"
                    : "text-foreground-600 hover:text-foreground-950")
                }
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        {/* Large cards */}
        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
          {FEATURES_BIG.map((f) => (
            <article
              key={f.title}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 sm:flex-row"
            >
              <div className="relative h-44 w-full overflow-hidden sm:h-auto sm:w-[42%]">
                <img
                  src={f.image}
                  alt={f.title}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex flex-wrap items-center gap-2">
                  <span
                    className={
                      "whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold " +
                      (f.tagTone === "primary"
                        ? "bg-primary-500 text-background-50"
                        : "bg-accent-500 text-foreground-950")
                    }
                  >
                    {f.tag}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs text-primary-600">
                    <i className="ri-fire-line" /> 精选
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                  <a href="#featured">{f.title}</a>
                </h3>
                <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">{f.summary}</p>
                <div className="mt-4 flex flex-wrap items-center gap-x-3 gap-y-1 border-t border-background-200 pt-3 text-xs text-foreground-500">
                  {f.meta.map((m) => (
                    <span key={m} className="whitespace-nowrap">
                      {m}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Small cards */}
        <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES_SMALL.map((f, i) => (
            <article
              key={f.title}
              className="group overflow-hidden rounded-xl border border-background-200 bg-background-50 transition hover:-translate-y-1 hover:border-secondary-300"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={f.image}
                  alt={f.title}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 whitespace-nowrap rounded-full bg-background-950/60 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
                  {f.tag}
                </span>
              </div>
              <div className="p-4">
                <h4 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
                  <a href="#featured">{f.title}</a>
                </h4>
                <div className="mt-2 flex items-center justify-between">
                  <span className="inline-flex items-center gap-1 text-xs text-accent-600">
                    <i className="ri-fire-fill" /> {f.heat} 热度
                  </span>
                  <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                    第 {i + 1} 组切片
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}